"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPaymentSkeletonDesktop = function SvgPaymentSkeletonDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 636 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 636,
    height: 244,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h620v116H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 19.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 27h252.5M18 42h602M18 58h602M18 74h602M18 90h602M18 106h537",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 124h620v118H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 135.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 143h252.5M18 158h602M18 174h602M18 190h602M18 206h602M18 222h537",
    stroke: "#E6E6E6"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPaymentSkeletonDesktop);
var _default = exports["default"] = Memo;